/**
 * Ambient aurora background — no cursor tracking, no hover effects.
 * Just a slow color-cycling wash and a soft powder grain.
 */
export default function InteractiveAurora() {
  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      {/* Ambient breathing color wash — hue-cycles slowly */}
      <div className="hero-aurora-color"></div>

      {/* Grain overlay for that dusty powder texture */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none opacity-[0.18] mix-blend-overlay"
        xmlns="http://www.w3.org/2000/svg"
      >
        <filter id="powder-noise-hero">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.85"
            numOctaves="2"
            stitchTiles="stitch"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#powder-noise-hero)" />
      </svg>

      {/* Soft top/bottom fades so composition stays airy */}
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-background-50 to-transparent pointer-events-none"></div>
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-background-50 to-transparent pointer-events-none"></div>
    </div>
  );
}